"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/AuthFrame/FieldError.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _icons = require('./icons');







// One sentence under a field, saying what is wrong with it.
const FieldError = ({ id, className, children }) => (
  children
    ? (
        _react2.default.createElement('p', { id: id, className: _classBuilder2.default.call(void 0, 'auth-field-error', className), role: "alert", __self: this, __source: {fileName: _jsxFileName, lineNumber: 16}}
          , _react2.default.createElement(_icons.AlertIcon, { size: 16, className: "auth-field-error--icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 17}} )
          , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 18}},  children )
        )
      )
    : null
)

exports. default = FieldError
